import { h } from 'preact';
export const RotateCw = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "23 4 23 10 17 10" }),
        h("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })));
};
//# sourceMappingURL=rotate-cw.js.map